import { render, staticRenderFns } from "./Phones.vue?vue&type=template&id=2423c6c0"
import script from "./Phones.vue?vue&type=script&lang=js"
export * from "./Phones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports